import { __assign } from "tslib";
import { namespacedClassnames } from '../../common';
import { Toggle } from '../../primitives/toggle/toggle';
import * as React from 'react';
import { HeightAnimation } from '../../animations/height/height';
import { Tooltip } from '../../primitives';
export var CollapsbileToggle = function (props) {
    var val = props.value;
    var disabled = props.disabled;
    var classNames = namespacedClassnames('collapsible-toggle', { on: val.toggled, expanded: val.expanded });
    var toggleCollapse = function () {
        props.onChange(__assign(__assign({}, val), { expanded: !val.expanded }));
    };
    var toggle = function () {
        var shouldCollapse = val.expanded && val.toggled;
        var expanded = shouldCollapse ? false : val.expanded;
        props.onChange({ expanded: expanded, toggled: !val.toggled });
    };
    var tooltipBody = React.createElement("div", { className: 'toggle-tooltip-body' }, disabled);
    var renderToggle = (React.createElement(Toggle, { value: val.toggled, onChange: toggle, disabled: !!props.disabled }));
    return (React.createElement("span", { className: classNames },
        React.createElement("div", { className: "collapsible-header " + (val.expanded && props.highlightExpandedHeader ? 'highlight-expended' : '') },
            React.createElement("span", { className: 'header-title', onClick: toggleCollapse }, props.title),
            React.createElement("span", { className: 'toggle-wrapper' }, disabled ? React.createElement(Tooltip, { relativeToBody: true, body: tooltipBody }, renderToggle) : renderToggle)),
        React.createElement("div", { className: 'collapsible-body' },
            React.createElement(HeightAnimation, { show: val.expanded },
                React.createElement("div", { className: 'body-wrapper' }, props.children)))));
};
//# sourceMappingURL=collapsible-toggle.js.map